module.exports = __webpack_public_path__ + "static/media/login-bottom-ellipse.3daca931.png";